import React from 'react'
import dynamic from 'next/dynamic'
import useTranslation from 'next-translate/useTranslation'

import useWindowSize from '@shared/hooks/windowSize'
import { useQuery } from '@apollo/client'
import { LIST_WEB_STORIES } from '@graphql/web-stories/web-stories.query'
import Stories from '@shared/components/stories'
import Slider from '@shared/components/slider'

const StoriesLightBox = dynamic(() => import('@shared/components/stories/stories-light-box'))
// const Stories = dynamic(() => import('@shared/components/stories'), { loading: () => <div style={{ width: 150 }}></div> })

function ArticleStories() {
  const { t } = useTranslation()
  const [width] = useWindowSize()

  const { data } = useQuery(LIST_WEB_STORIES, { variables: { input: { nSkip: 0, nLimit: 10 } } })

  if (data?.listWebStoryFront?.aWebStory?.length) {
    return (
      <section className="mt-3 mt-md-0 mb-2 mb-md-3">
        <StoriesLightBox data={data?.listWebStoryFront?.aWebStory} />
        <h3 className="small-head text-uppercase">{t('common:CricStories')}</h3>
        <Slider
          gap={10}
          nav={width > 1199}
          destroyBelow={2200}
          navClass="mx-3"
          id="enable-stories-player"
        >
          {data?.listWebStoryFront?.aWebStory?.map((data, index) => (
            <div
              key={data?._id}
              className='d-flex flex-shrink-0'
              style={{ width: 150 }}
            >
              <Stories
                data={data}
                className='w-100'
              />
            </div>
          ))}
        </Slider>
      </section>
    )
  } else return null
}
export default ArticleStories
